import "./BaseModalComp.css";
import { defineComponent as F, useSlots as I, computed as r, openBlock as o, createElementBlock as l, normalizeStyle as L, normalizeClass as g, createVNode as d, createCommentVNode as a, createBlock as f, withCtx as u, renderSlot as i, resolveDynamicComponent as O, createElementVNode as h, toDisplayString as m, createTextVNode as A } from "vue";
import { IconComp as v } from "./IconComp.js";
import { ButtonComp as y } from "./ButtonComp.js";
import { ContainedIconComp as D } from "./ContainedIconComp.js";
import { _ as H } from "./_plugin-vue_export-helper.dad06003.js";
const W = ["t-sel"], N = {
  key: 2,
  class: "baseModal__content"
}, V = {
  key: 2,
  class: "baseModal__message"
}, z = ["innerHTML"], E = {
  key: 4,
  class: "baseModal__altAction"
}, P = {
  key: 4,
  class: "baseModal__footer"
}, j = /* @__PURE__ */ F({
  __name: "BaseModalComp",
  props: {
    tSel: {},
    height: {},
    width: { default: "680px" },
    icon: {},
    iconHeight: { default: "50px" },
    iconWidth: { default: "50px" },
    iconColor: {},
    insetIcon: { type: Boolean },
    danger: { type: Boolean },
    title: {},
    leftAlignTitle: { type: Boolean },
    message: {},
    actionText: {},
    actionDisabled: { type: Boolean },
    actionWaiting: { type: Boolean },
    altActionText: {},
    altActionButtonStyle: {},
    actionButtonsOnSameLine: { type: Boolean },
    rightAlignActionButtons: { type: Boolean },
    footerText: {},
    hideCloseIcon: { type: Boolean },
    useForm: { type: Boolean },
    leftAlignAltAction: { type: Boolean }
  },
  emits: ["cancelled", "action", "altAction"],
  setup(b, { emit: C }) {
    const M = I(), t = b, p = C, T = r(() => ({
      minHeight: t.height,
      width: t.width
    })), B = r(() => t.icon ? t.icon : t.danger ? "error_large" : ""), k = r(() => t.useForm ? "form" : "div"), _ = r(() => ({
      baseModal__title: !0,
      "baseModal__title--leftAlign": t.leftAlignTitle
    })), $ = r(() => ({
      baseModal__action: !0,
      "baseModal__action--actionButtonsOnSameLine": t.actionButtonsOnSameLine,
      "baseModal__action--rightAlignActionButtons": t.rightAlignActionButtons
    })), S = r(() => {
      const e = { anchorStyle: !0 };
      return t.altActionButtonStyle && {
        AnchorStyle: { anchorStyle: !0 },
        SecondaryWhite: { anchorStyle: !1 }
      }[t.altActionButtonStyle] || e;
    }), s = (e) => !!M[e], w = (e) => {
      t.useForm && e.preventDefault();
    };
    return (e, n) => (o(), l("div", {
      class: "baseModal",
      "t-sel": e.tSel,
      style: L(T.value)
    }, [
      (e.icon || e.danger) && !e.insetIcon ? (o(), l("div", {
        key: 0,
        class: g({ baseModal__icon: !0, "baseModal__icon--danger": e.danger })
      }, [
        d(v, {
          icon: B.value,
          height: e.iconHeight,
          width: e.iconWidth,
          color: e.iconColor ?? "#FFFFFF"
        }, null, 8, ["icon", "height", "width", "color"])
      ], 2)) : a("", !0),
      e.hideCloseIcon ? a("", !0) : (o(), f(y, {
        key: 1,
        class: "baseModal__close",
        "aria-label": "Close modal",
        onClick: n[0] || (n[0] = (c) => p("cancelled")),
        "t-sel": `${e.tSel}-closeModalBtn`,
        blank: ""
      }, {
        default: u(() => [
          d(v, { icon: "close_small" })
        ]),
        _: 1
      }, 8, ["t-sel"])),
      s("content") ? (o(), l("div", N, [
        i(e.$slots, "content", {}, void 0, !0)
      ])) : (o(), f(O(k.value), {
        key: 3,
        onSubmit: n[4] || (n[4] = (c) => w(c)),
        class: "baseModal__content"
      }, {
        default: u(() => [
          (e.icon || e.danger) && e.insetIcon ? (o(), f(D, {
            key: 0,
            icon: B.value,
            height: e.iconHeight,
            width: e.iconWidth,
            color: e.iconColor ?? "#0068AD"
          }, null, 8, ["icon", "height", "width", "color"])) : a("", !0),
          e.title || s("title") ? (o(), l("div", {
            key: 1,
            class: g(_.value)
          }, [
            i(e.$slots, "title", { title: e.title }, () => [
              h("p", null, m(e.title), 1)
            ], !0)
          ], 2)) : a("", !0),
          e.message || s("message") ? (o(), l("div", V, [
            i(e.$slots, "message", { message: e.message }, () => [
              h("p", { innerHTML: e.message }, null, 8, z)
            ], !0)
          ])) : a("", !0),
          i(e.$slots, "default", {}, void 0, !0),
          e.actionText || s("action") ? (o(), l("div", {
            key: 3,
            class: g($.value)
          }, [
            e.actionButtonsOnSameLine && (e.altActionText || s("altActionText")) ? (o(), l("div", {
              key: 0,
              class: g({
                baseModal__altAction: !0,
                "baseModal__altAction--leftAlignAltAction": t.leftAlignAltAction
              })
            }, [
              i(e.$slots, "altActionText", {}, () => [
                d(y, {
                  onClick: n[1] || (n[1] = (c) => p("altAction")),
                  "t-sel": `${e.tSel}-altActionBtn`,
                  anchorStyle: S.value.anchorStyle,
                  large: ""
                }, {
                  default: u(() => [
                    A(m(e.altActionText), 1)
                  ]),
                  _: 1
                }, 8, ["t-sel", "anchorStyle"])
              ], !0)
            ], 2)) : a("", !0),
            i(e.$slots, "action", {}, () => [
              d(y, {
                onClick: n[2] || (n[2] = (c) => p("action")),
                type: "submit",
                "t-sel": `${e.tSel}-actionBtn`,
                disabled: e.actionDisabled,
                waiting: e.actionWaiting,
                legacyOrange: "",
                large: ""
              }, {
                default: u(() => [
                  A(m(e.actionText), 1)
                ]),
                _: 1
              }, 8, ["t-sel", "disabled", "waiting"])
            ], !0)
          ], 2)) : a("", !0),
          !e.actionButtonsOnSameLine && (e.altActionText || s("altActionText")) ? (o(), l("div", E, [
            i(e.$slots, "altActionText", {}, () => [
              d(y, {
                class: "baseModal__altActionBtn",
                onClick: n[3] || (n[3] = (c) => p("altAction")),
                "t-sel": `${e.tSel}-altActionBtn`,
                anchorStyle: S.value.anchorStyle,
                large: ""
              }, {
                default: u(() => [
                  A(m(e.altActionText), 1)
                ]),
                _: 1
              }, 8, ["t-sel", "anchorStyle"])
            ], !0)
          ])) : a("", !0)
        ]),
        _: 3
      }, 32)),
      e.footerText || s("footer") ? (o(), l("div", P, [
        i(e.$slots, "footer", {}, () => [
          h("p", null, m(e.footerText), 1)
        ], !0)
      ])) : a("", !0)
    ], 12, W));
  }
});
const U = /* @__PURE__ */ H(j, [["__scopeId", "data-v-0f7233ff"]]);
export {
  U as BaseModalComp
};
//# sourceMappingURL=BaseModalComp.js.map
